<template>
  <div class="change-password-container">
    <div class="change-password-card">
      <div class="change-password-header">
        <h2 class="change-password-title">修改密码</h2>
      </div>
      
      <el-form :model="passwordForm" :rules="passwordRules" ref="passwordForm" class="password-form" label-width="100px">
        <el-form-item label="原密码" prop="oldPassword">
          <el-input 
            v-model="passwordForm.oldPassword"
            type="password"
            show-password
            placeholder="请输入原密码">
          </el-input>
        </el-form-item>
        
        <el-form-item label="新密码" prop="newPassword">
          <el-input 
            v-model="passwordForm.newPassword"
            type="password"
            show-password
            placeholder="请输入新密码">
          </el-input>
          <div class="form-tip pwd-strength-tip">密码须≥8位，包含大小写字母、数字及特殊符号</div>
        </el-form-item>
        
        <el-form-item label="确认密码" prop="confirmPassword">
          <el-input 
            v-model="passwordForm.confirmPassword"
            type="password"
            show-password
            placeholder="请确认新密码">
          </el-input>
        </el-form-item>
        
        <el-form-item>
          <el-button type="primary" :loading="loading" @click="handleChangePassword">
            确认修改
          </el-button>
          <el-button @click="goBack">
            返回
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { changePassword } from '@/api/auth'
import { encryptPassword } from '@/utils/password'

export default {
  name: 'ChangePassword',
  data() {
    // 新密码强度验证
    const validateNewPassword = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入新密码'))
      }
      if (value.length < 8) {
        return callback(new Error('密码长度不能少于8位'))
      }
      if (!/[A-Z]/.test(value)) {
        return callback(new Error('密码必须包含大写字母'))
      }
      if (!/[a-z]/.test(value)) {
        return callback(new Error('密码必须包含小写字母'))
      }
      if (!/[0-9]/.test(value)) {
        return callback(new Error('密码必须包含数字'))
      }
      if (!/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?`~]/.test(value)) {
        return callback(new Error('密码必须包含特殊符号（如 !@#$%^&* 等）'))
      }
      callback()
    }

    // 确认密码验证
    const validateConfirmPassword = (rule, value, callback) => {
      if (value !== this.passwordForm.newPassword) {
        callback(new Error('两次输入的密码不一致'))
      } else {
        callback()
      }
    }
    
    return {
      passwordForm: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      passwordRules: {
        oldPassword: [
          { required: true, message: '请输入原密码', trigger: 'blur' }
        ],
        newPassword: [
          { validator: validateNewPassword, trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '请确认新密码', trigger: 'blur' },
          { validator: validateConfirmPassword, trigger: 'blur' }
        ]
      },
      loading: false
    }
  },
  methods: {
    handleChangePassword() {
      this.$refs.passwordForm.validate(async valid => {
        if (valid) {
          this.loading = true
          try {
            // 加密密码
            const oldPasswordEncrypted = encryptPassword(this.passwordForm.oldPassword)
            const newPasswordEncrypted = encryptPassword(this.passwordForm.newPassword)
            
            // 发送修改密码请求
            const response = await changePassword({
              oldPassword: oldPasswordEncrypted,
              newPassword: newPasswordEncrypted,
              confirmPassword: newPasswordEncrypted
            })
            
            // 处理响应
            if (response.code === 200) {
              this.$message({
                message: '密码修改成功，请重新登录',
                type: 'success'
              })
              
              // 清除登录信息，退出登录
              localStorage.removeItem('token')
              localStorage.removeItem('username')
              
              // 跳转到登录页
              this.$router.push('/login')
            } else {
              throw new Error(response.message || '密码修改失败')
            }
          } catch (error) {
            console.error(error)
            this.$message({
              message: error.message || '密码修改失败，请稍后再试',
              type: 'error'
            })
          } finally {
            this.loading = false
          }
        }
      })
    },
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
.change-password-container {
  padding: 30px;
}

.change-password-card {
  max-width: 600px;
  margin: 0 auto;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  padding: 30px;
}

.change-password-header {
  text-align: center;
  margin-bottom: 30px;
}

.change-password-title {
  color: #303133;
  font-weight: 500;
  margin: 0;
  font-size: 22px;
}

.password-form {
  margin-top: 20px;
}

.form-tip {
  font-size: 12px;
  color: #909399;
  margin-top: 4px;
  line-height: 1.4;
}

.pwd-strength-tip {
  color: #e6a23c;
}
</style> 